import React from "react"

const SocialShare = (props) => {
    //console.log(props)

    //const { location, title} = props

    const currentURL = props.siteUrl + props.location
    //console.log(props.siteUrl)

    return (
        <div>
            If you enjoyed this post consider sharing it on {" "}
            <a className="shareLink" target="_blank" href={`https://twitter.com/intent/tweet?url=${currentURL}&text=${props.title}`}>Twitter</a>,{" "}
            <a className="shareLink" target="_blank" href={`http://www.reddit.com/submit?url=${currentURL}&title=${props.title}`}>Reddit</a>,{" "}
            <a className="shareLink" target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`}>Facebook</a>, or{" "}
            <a className="shareLink" target="_blank" href={`http://www.linkedin.com/shareArticle?mini=true&url=${currentURL}&title=${props.title}`}>LinkedIn</a>,{" "}
            and <a className="shareLink" target="_blank" href="https://twitter.com/mdjxkln">following me on Twitter</a>.
        </div>
    )
}

export default SocialShare;